import React from 'react';
import { Modal, Button, Badge, Table } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';
import { getDeviceShareUrl } from '../../utils/shareLinks';

const PaymentDetailModal = ({ show, onHide, payment, loading }) => {
  const navigate = useNavigate();

  if (!payment && !loading) return null;

  const formatUsd = (val) => (val != null ? `$${Number(val).toFixed(2)}` : '—');

  const originalAmount = payment?.original_amount ?? payment?.price_in_purchased_currency ?? payment?.price;
  const originalCurrency = payment?.original_currency ?? payment?.currency;
  const showOriginal =
    originalAmount != null &&
    originalCurrency &&
    originalCurrency !== 'USD';

  return (
    <Modal show={show} onHide={onHide} size="lg" centered scrollable fullscreen="md-down">
      <Modal.Header closeButton>
        <Modal.Title>Payment detail</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {loading ? (
          <p className="text-muted mb-0">Loading…</p>
        ) : (
          <Table bordered size="sm" className="mb-0">
            <tbody>
              <tr><th style={{ width: '40%' }}>Event type</th><td><Badge bg="primary" className="text-white">{payment.event_type}</Badge></td></tr>
              <tr><th>Device ID</th><td className="font-monospace small">{payment.device_id}</td></tr>
              <tr><th>Product</th><td className="font-monospace small">{payment.product_id}</td></tr>
              <tr><th>Amount (USD)</th><td>{formatUsd(payment.price_usd ?? payment.display_amount)}</td></tr>
              {showOriginal && (
                <tr>
                  <th>Store price</th>
                  <td>{Number(originalAmount).toFixed(2)} {originalCurrency}</td>
                </tr>
              )}
              {payment.fx_rate_to_usd != null && showOriginal && (
                <tr><th>FX rate to USD</th><td>{payment.fx_rate_to_usd}</td></tr>
              )}
              <tr><th>Store</th><td>{payment.store || '—'}</td></tr>
              <tr><th>Environment</th><td>{payment.environment || '—'}</td></tr>
              <tr><th>Country</th><td>{payment.country_code || '—'}</td></tr>
              <tr><th>Purchased at</th><td>{payment.purchased_at || '—'}</td></tr>
              <tr><th>Offering</th><td>{payment.presented_offering_id || '—'}</td></tr>
              <tr><th>Entitlements</th><td>{(payment.entitlement_ids || []).join(', ') || '—'}</td></tr>
              <tr><th>Transaction ID</th><td className="font-monospace small">{payment.external_txn_id || '—'}</td></tr>
              <tr><th>Event ID</th><td className="font-monospace small">{payment.event_id || '—'}</td></tr>
              <tr><th>Status</th><td>{payment.status}</td></tr>
            </tbody>
          </Table>
        )}
      </Modal.Body>
      <Modal.Footer>
        {payment?.device_id && (
          <>
            <Button
              variant="outline-success"
              href={getDeviceShareUrl(payment.device_id)}
              target="_blank"
              rel="noopener noreferrer"
            >
              <FontAwesomeIcon icon={faExternalLinkAlt} className="me-1" />
              Open share link
            </Button>
            <Button
              variant="outline-primary"
              onClick={() => {
                onHide();
                navigate(`/devices/detail?device_id=${encodeURIComponent(payment.device_id)}`);
              }}
            >
              Open device
            </Button>
          </>
        )}
        <Button variant="secondary" onClick={onHide}>Close</Button>
      </Modal.Footer>
    </Modal>
  );
};

export default PaymentDetailModal;
